<!-- Form select input for choosing a country from a translated, alphabetically sorted list. -->

<script lang="ts" setup>
import type { CountryCode } from '@nzyme/i18n/Country.js';
import { CountryTranslations } from '@nzyme/i18n/Country.js';
import { useTranslate } from '@nzyme/vue-i18n/useTranslate.js';
import type { Slots } from '@nzyme/vue-utils/slots.js';
import { useEmitAsProps } from '@nzyme/vue-utils/useEmitAsProps.js';
import { computed } from 'vue';

import * as l from './CountryInput.loc.js';
import SelectInput, { SelectInputEmits, SelectInputProps } from './SelectInput.vue';

defineProps(SelectInputProps);
defineEmits(SelectInputEmits);

defineSlots<Slots<{ info: undefined }>>();

const emits = useEmitAsProps();

const t = useTranslate();

const countries = computed(() => {
  return Object.keys(CountryTranslations)
    .map(code => ({
      code: code as CountryCode,
      name: t(CountryTranslations[code as CountryCode]),
    }))
    .toSorted((a, b) => a.name.localeCompare(b.name));
});
</script>

<template>
  <SelectInput
    autocomplete="country"
    v-bind="{ ...emits, ...$props }"
    :label="$props.label || t(l.countryLabel)"
  >
    <template #default>
      <option
        value=""
        disabled
      >
        {{ t(l.selectCountry) }}
      </option>
      <option
        v-for="country in countries"
        :key="country.code"
        :value="country.code"
      >
        {{ country.name }}
      </option>
    </template>

    <template #info>
      <slot name="info" />
    </template>
  </SelectInput>
</template>
